import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

// Pages
import AuthenticatedRootPage from '@pages/AuthenticatedRootPage.page';
import UnauthenticatedRootPage from '@pages/UnauthenticatedRootPage.page';
import ErrorPage from '@pages/Error.page';
import ApiConnectionErrorPage from '@pages/ApiConnectionErrorPage.page';
import Welcome from '@pages/Welcome.page';
import CreateNewAccount from '@pages/CreateNewAccount.page';
import AfterLogin from '@pages/AfterLogin.page';
import ReportingPage from '@pages/Reporting.page';
import RelationshipConnections from '@pages/RelationshipConnections.page';
import SourceConfigPage from '@pages/SourceConfig.page';
import CleaningPage from '@pages/Cleaning.page';
import AccountSignup from '@pages/AccountSignup.page';
import BusinessObjectRecordLineage from '@pages/BusinessObject/BusinessObjectRecordLineage.page';
import SourceSideBySidePage from '@pages/SourceSideBySide.page';
import NoNavWrapperPage from '@pages/Onboarding/OnboardingWrapper.page';
import DatabaseSetupPage from '@pages/Onboarding/DatabaseSetup.page';
import NewSourcePage from '@pages/NewSourcePage.page';

import StartTemplatePage from '@pages/Template/StartTemplate.page';
import ViewTemplateGroupPage from '@pages/Template/ViewTemplateGroup.page';
import FivetranSourceStepReturnPage from '@pages/Template/steps/FivetranSourceStepReturn.page';

import BusinessObjectWrapperPage from '@pages/BusinessObject/BusinessObjectWrapper.page';
import BusinessObjectFieldsPage from '@pages/BusinessObject/BusinessObjectFields.page';
import BusinessObjectDataPage from '@pages/BusinessObject/BusinessObjectData.page';
import SourceRecordTypeWrapperPage from '@pages/SourceRecordType/SourceRecordTypeWrapper.page';
import BusinessObjectRelationshipsPage from '@pages/BusinessObject/BusinessObjectRelationships.page';
import SourceFinishFivetranPage from '@pages/SourceFinishFivetran.page';

import PipelineNodeWrapperPage from '@pages/PipelineNode/PipelineNodeWrapper';
import PipelineNodeDataPage from '@pages/PipelineNode/PipelineNodeData';
import PipelineNodeRelationshipPage from '@pages/PipelineNode/PipelineNodeRelationships.page';
import PipelineNodeFiltersPage from '@pages/PipelineNode/PipelineNodeFilters.page';
import PipelineNodesListPage from '@pages/PipelineNode/PipelineNodesList.page';
import TenantReturn from '@pages/TenantReturn.page';
import TenantBuildSchedulerPage from '@pages/TenantConfig/TenantBuildScheduler.page';
import DataAssistantPage from '@pages/Assistant.page';

import DataExplorerPage from '@pages/DataExplorer.page';
import NewPipelineNodePage from '@pages/PipelineNode/NewPipelineNode.page';
import GithubIntegrationPage from '@pages/Onboarding/GithubIntegration.page';
import PipelineNodeConfigurationPage from '@pages/PipelineNode/PipelineNodeConfiguration.page';
import SeedPage from '@pages/Seeds/Seed.page';
import TenantGitSetupPage from '@pages/TenantConfig/TenantGitSetup.page';
import BuildHistoryPage from '@pages/BuildHistory.page';
import DagPage from '@pages/Dag.page';
import PipelineNodeVisualizationsPage from '@pages/PipelineNode/PipelineNodeVisualizations.page';
import PipelineNodeVisualizationPage from '@pages/PipelineNode/PipelineNodeVisualization.page';
import OnboardingWizardPage from '@pages/Onboarding/OnboardingWizard.page';
import TenantAuthorizeSourcesPage from '@pages/TenantConfig/TenantAuthorizeSources.page';
import DashboardEditorPage from '@pages/Dashboard/DashboardEditor.page';
import HomePage from '@pages/Home.page';


const createRoutes = () => {
    return (
    <Route path="" errorElement={<ErrorPage/>}>
        <Route element={<AuthenticatedRootPage/>}>
            <Route index element={<HomePage/>}/>
            <Route path="dag" element={<DagPage/>}/>
            <Route path="welcome" element={<Welcome/>}/>
            <Route path="create-account" element={<CreateNewAccount />}/>   
            <Route path="unable-to-connect" element={<ApiConnectionErrorPage />}/>
            <Route path="afterlogin" element={<AfterLogin />}/>  
            <Route path="tenant-return/:tenantUuid" element={<TenantReturn />}/> 
            <Route path="account" element={<TenantBuildSchedulerPage />}/> 
            <Route path="account/build-schedule" element={<TenantBuildSchedulerPage />}/> 
            <Route path="account/authorize-sources" element={<TenantAuthorizeSourcesPage />}/> 
           
            <Route path="reporting/:dataMartId" element={<ReportingPage/>}/>
            <Route path="relationship/:relationshipId/connections" element={<RelationshipConnections/>}/>
            <Route path="source/new" element={<NewSourcePage/>}></Route>
            <Route path="source/:sourceId" element={<SourceConfigPage/>}/>
            <Route path="source/:sourceId/finish-fivetran" element={<SourceFinishFivetranPage/>}/>
            <Route path="data/sidebyside/:srt1Id/:srt2Id" element={<SourceSideBySidePage/>}/>

            <Route path="dashboard/:dashboardId" element={<DashboardEditorPage/>}/>

            <Route path="onboarding" element={<NoNavWrapperPage/>}>
                <Route index element={<OnboardingWizardPage/>}/>
                <Route path="step/:step" element={<OnboardingWizardPage/>}/>
                <Route path="database" element={<DatabaseSetupPage/>}/>
                <Route path="github" element={<GithubIntegrationPage/>}/>
            </Route>

            <Route path="business-object/:businessObjectId" element={<BusinessObjectWrapperPage/>}>
                <Route index element={<BusinessObjectDataPage/>}/>
                <Route path="fields" element={<BusinessObjectFieldsPage/>}/>

                <Route path="relationships" element={<BusinessObjectRelationshipsPage/>}/>
                <Route path="data/record/:recordId" element={<BusinessObjectRecordLineage/>}/>
            </Route>
            {/* <Route path="database" element={<DataExplorerPage/>}/> */}
            <Route path="nodes" element={<PipelineNodesListPage/>}/>
            <Route path="node/new" element={<NewPipelineNodePage/>}/>
            <Route path="node/:pipelineNodeId" element={<PipelineNodeDataPage/>}/>
                
            <Route path="node/:pipelineNodeId/config" element={<PipelineNodeConfigurationPage/>}/>
            <Route path="node/:pipelineNodeId/visualizations" element={<PipelineNodeVisualizationsPage/>}/>
            <Route path="node/:pipelineNodeId/visualizations/:visualizationId" element={<PipelineNodeVisualizationPage/>}/>

            <Route path="node/:pipelineNodeId/relationships" element={<PipelineNodeRelationshipPage/>}/>
            <Route path="node/:pipelineNodeId/relationships/:relationshipId" element={<PipelineNodeRelationshipPage/>}/>
            <Route path="node/:pipelineNodeId/data/record/:recordId" element={<BusinessObjectRecordLineage/>}/>
            <Route path="data-source/:sourceRecordTypeId" element={<SourceRecordTypeWrapperPage/>}/>

            <Route path="advanced">
                <Route path="new" element={<NewSourcePage/>} />
            </Route>
            <Route path="seeds/:seedId" element={<SeedPage/>}/>

            <Route path="template/:templateId" element={<StartTemplatePage />}/>
            <Route path="template-group/:templateGroupId" element={<ViewTemplateGroupPage />}/>
            <Route path="template-group/:templateGroupId/source/:sourceId/finish-fivetran" element={<FivetranSourceStepReturnPage />}/>
            <Route path="data-assistant" element={<DataAssistantPage/>}/>
            <Route path="builds" element={<BuildHistoryPage/>}/>
        </Route>
        <Route element={<UnauthenticatedRootPage/>}>
            <Route path="signup" element={<AccountSignup/>}/>    
            <Route path="sign-up-thank-you" element={<AccountSignup/>}/>           
        </Route>
        
    </Route>
    );
}

export default createRoutes;